// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false;
// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSThemeConfig.custom.products_per_page,
		// Optional
		loadProductFirst: true,
		styleScrollToTop: 'style2',
		defaultDisplay: boostPFSThemeConfig.custom.layout,
		showPlaceholderProductList: true
	},
};

(function() {
	BoostPFS.inject(this);
  
  
	ProductGridItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/
      
      
		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;
      	
		// Add a specific class for grid item
		var itemGridWidthClass = '';
		var imageSize = '600x600';

		switch (boostPFSConfig.custom.products_per_row) {
			case 2:
				itemGridWidthClass = 'medium-up--one-half';
				imageSize = '540x600';
				break;
			case 3:
				itemGridWidthClass = 'small--one-half medium-up--one-third';
				imageSize = '345x550';
				break;
			case 4:
				itemGridWidthClass = 'small--one-half medium-up--one-quarter';
				imageSize = '250x';
				break;
			case 5:
				itemGridWidthClass = 'small--one-half medium-up--one-fifth';
				imageSize = '195x';
				break;
		}
		itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, itemGridWidthClass);

		// Add soldOut class
		var itemSoldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);

		// Add soldOut label
		var itemSoldOutLabel = soldOut ? boostPFSTemplate.soldOutLabelGridHtml : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

		var imgId = 'ProductCardImage-' + data.id;
		var wrapperId = 'ProductCardImageWrapper-' + data.id;

		// Build Image style
		var imageStyle = buildImageStyle(data);
		itemHtml = itemHtml.replace(/{{imageStyle}}/g, imageStyle);

		// Add Images
		var aspect_ratio = '';
		var itemImagesHtml = '<div id="' + wrapperId + '" class="grid-view-item__image-wrapper js">';
		itemImagesHtml += '<div style="padding-top:';
		if (images.length > 0) {
			aspect_ratio = images[0]['width'] / images[0]['height'];
			itemImagesHtml += 1 / aspect_ratio * 100;
		} else {
			itemImagesHtml += 100;
		}
		itemImagesHtml += '%;">';
		itemImagesHtml += '<img id="' + imgId + '" ' +
			'class="grid-view-item__image lazyload" ' +
			'src="' + Utils.getFeaturedImage(images, '300x300') + '" ' +
			'data-src="' + Utils.getFeaturedImage(images, '{width}x') + '" ' +
			'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ' +
			'data-aspectratio="' + aspect_ratio + '" ' +
			'data-sizes="auto" ' +
			'alt="{{itemTitle}}">';
		itemImagesHtml += '</div>';
		itemImagesHtml += '</div>';

		var image_size = boostPFSConfig.custom.max_height + 'x' + boostPFSConfig.custom.max_height;
		var max_width = images.length > 0 ? boostPFSConfig.custom.max_height * aspect_ratio : 0;
		itemImagesHtml += '<noscript><img class="grid-view-item__image" src="' + Utils.getFeaturedImage(images, image_size + '@2x') + '" alt="{{itemTitle}}" style="max-width: ' + max_width + 'px;"></noscript>';
// 		itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);
      
        var itemImageHtml = `<a class="c-product-tile__link-product" aria-label="${data.title}, ${numberWithCurrency(data.price_min)}" title="${data.title} Price ${numberWithCurrency(data.price_min)} ${ onSale ? "Price "+numberWithCurrency(data.compare_at_price_min)+"" : ''}" href="${Utils.buildProductItemUrl(data)}">
                                <span class="c-product-tile__content-wrapper c-product-tile__content-wrapper--is-square">
                                  <picture class="c-product-tile__content u-transition-delay-6 c-picture c-picture--is-loaded" aria-hidden="false">
                                    <img class="lazyload" 
                                         data-sizes="auto" 
                                         src="${Utils.getFeaturedImage(images, '300x300')}"
                                         data-src="${Utils.getFeaturedImage(images, '{width}x')}" 
                                         alt="${data.title}"
                                         data-aspectratio="${aspect_ratio}"
                                         data-widths="[160, 300, 400, 525, 650, 800, 1000]">
                                  </picture>
                                </span>
                              </a>`;
     

		// console.log("data", data)
        var wishListAttributes = `data-epi="${firstVariant.id}" data-du="${Utils.buildProductItemUrl(data)}" data-empi="${data.id}" data-iu="${Utils.getFeaturedImage(images, '525x525')}" data-pr="${data.price_min}" data-stk="${firstVariant.inventory_quantity}"`;
        
        
		itemHtml = itemHtml.replace(/{{wishListAttributes}}/g, wishListAttributes);
      
		itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImageHtml);

		// Add Vendor
		var itemVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorGridHtml : '';
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

// 		var itemPriceHtml = buildPrice(data, onSale, priceVaries);
		var itemPriceHtml = newBuildPrice(data, onSale);
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
      
      	//Percent sale
      	var percentSaleHtml = percentSaleTag(data, onSale);
      	itemHtml = itemHtml.replace(/{{percentSaleTag}}/g, percentSaleHtml);

		// Add main attribute
		// console.log("product title", data.title)
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title.split(" ")[0]);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

		var _tagsPDP = ['BED Foam','Comfort Technology']
        var pdpFeat = null
        var __tags = data.tags
        if (__tags.filter(tag => tag == "BED Foam" ).length == 1 ) {
			if(	__tags.filter(tag => tag == "Women").length == 1) {
				pdpFeat = `<a href="https://callitspring.com.ph/collections/comfort-technology-women"><img class="lazyload" data-sizes="auto" src="https://cdn.shopify.com/s/files/1/0513/5826/9610/files/BED-Foam.png?v=1654681683"></a>`; 
			} else if (__tags.filter(tag => tag == "Men").length == 1) {
				pdpFeat = `<a href="https://callitspring.com.ph/collections/comfort-technology-men"><img class="lazyload" data-sizes="auto" src="https://cdn.shopify.com/s/files/1/0513/5826/9610/files/BED-Foam.png?v=1654681683"></a>`; 	
			}
			
        } else {
            pdpFeat = ` <img class="lazyload" data-sizes="auto"src="" style="opacity: 0;">`;
        }

		if(pdpFeat !== null) itemHtml = itemHtml.replace(/{{itemPDP}}/g, pdpFeat);

		return itemHtml;
	}

	ProductListItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/

		// Get Template
		var itemHtml = boostPFSTemplate.productListItemHtml;

		// Add onSale label
		var itemSaleLabel = onSale ? boostPFSTemplate.saleLabelListHtml : '';
		itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabel);

		// Add soldOut label
		var itemSoldOutLabel = soldOut ? boostPFSTemplate.soldOutLabelListHtml : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

		// Add Thumbnail
		var itemThumbUrl = images.length > 0 ? Utils.optimizeImage(images[0]['src'], '600x600') : boostPFSConfig.general.no_image_url;
		itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

		// Add Vendor
		var itemSmallVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorSmallListHtml : '';
		itemHtml = itemHtml.replace(/{{itemSmallVendor}}/g, itemSmallVendorHtml);
		var itemMediumVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorMediumListHtml : '';
		itemHtml = itemHtml.replace(/{{itemMediumVendor}}/g, itemMediumVendorHtml);

		// Add Price
// 		var itemPriceHtml = buildPrice(data, onSale, priceVaries);
		var itemPriceHtml = newBuildPrice(data, onSale);
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
      
      	//Percent sale
      	var percentSaleHtml = percentSaleTag(data, onSale);
      	itemHtml = itemHtml.replace(/{{percentSaleTag}}/g, percentSaleHtml);

		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemPriceMin}}/g, Utils.formatMoney(data.price_min));
		itemHtml = itemHtml.replace(/{{itemCompareAtPrice}}/g, Utils.formatMoney(data.compare_at_price_min));
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

		return itemHtml;
	}
  
  	function newBuildPrice(data, onSale) {
  		var priceHtml = '';

		let isSoldOut = false
		if(data.variants !== undefined && data.variants.length > 0) {
			const x = data.variants.filter(item => item.available == true )
			if(x.length == 0) {
				isSoldOut = true
			}
		}

		if(data.variants !== undefined && isSoldOut == true) {
			priceHtml =`<span class="c-product-price__formatted-price" style="color: red;"><strong>Sold out</strong></span>`
		} else {
			if(onSale) {
				priceHtml = `<span class="c-product-price__formatted-price c-product-price__formatted-price--original u-text-strikethrough">${Utils.formatMoney(data.compare_at_price_min)}</span>
				<span class="c-product-price__formatted-price c-product-price__formatted-price--is-reduced" style="color: rgb(83, 0, 170);">${Utils.formatMoney(data.price_min)}</span>`
			} else {
				priceHtml = `<span class="c-product-price__formatted-price c-product-price__formatted-price--is-reduced" style="color: rgb(83, 0, 170);">${Utils.formatMoney(data.price_min)}</span>`
			}
		}
      
      return priceHtml;
    }
    
    function percentSaleTag(data, onSale) {
      var tagHtml = '';
      if(onSale) {
        var percentSale = parseInt(100 - (data.price_min / data.compare_at_price_min * 100));
        tagHtml = `<div class="c-product-tile__product-special-tag">
      <div class="c-product-tile__after-product-special-tag">${percentSale}% Off</div>
    </div>`
      }
      
      return tagHtml;
    }

	// Build Image style
	function buildImageStyle(data) {
		var images = data.images_info;
		var imgId = 'ProductCardImage-' + data.id;
		var wrapperId = 'ProductCardImageWrapper-' + data.id;
		var imageStyle = '';
		if (images.length > 0) {
			var image = images[0];
			var width = boostPFSConfig.custom.max_height;
			var height = boostPFSConfig.custom.max_height;
			var aspect_ratio = image.width / image.height;
			var small_style = true;
			var container_aspect_ratio = width * 1.0 / height;

			if (image.aspect_ratio < 1.0) {
				var maximum_width = height * aspect_ratio;
				if (image.height <= height) {
					var maximum_height = image.height;
					maximum_width = image.width;
				} else {
					var maximum_height = height;
				}
			} else if (aspect_ratio < container_aspect_ratio) {
				var maximum_height = height / aspect_ratio;
				if (image.height <= height) {
					var maximum_height = image.height;
					var maximum_width = image.width;
				} else {
					var maximum_height = height;
					var maximum_width = height * aspect_ratio;
				}
			} else {
				var maximum_height = height / aspect_ratio;
				if (image.width <= width) {
					maximum_height = image.height;
					var maximum_width = image.width
				} else {
					var maximum_width = width;
					maximum_height = maximum_width / aspect_ratio;
				}
			}

			imageStyle += '<style>';
			if (small_style) imageStyle += '@media screen and (min-width: 750px) {';
			imageStyle += '#' + imgId + ' {' +
				'max-width: ' + maximum_width + 'px;' +
				'max-height: ' + maximum_height + 'px;' +
				'}' +
				'#' + wrapperId + ' {' +
				'max-width: ' + maximum_width + 'px;' +
				'max-height: ' + maximum_height + 'px;' +
				'}';
			if (small_style) imageStyle += '}';

			if (small_style) {
				if (aspect_ratio < 1) {
					maximum_width = 750 * aspect_ratio;
				} else {
					if (image.width < 750) {
						maximum_width = image.width;
					} else {
						maximum_width = 750;
					}
				}
				imageStyle += '@media screen and (max-width: 749px) {'
				imageStyle += '#' + imgId + ' {' +
					'max-width: ' + maximum_width + 'px;' +
					'max-height: 750px;' +
					'}' +
					'#' + wrapperId + ' {' +
					'max-width: ' + maximum_width + 'px;' +
					'}';
				imageStyle += '}';
			}
			imageStyle += '</style>';
		}
		return imageStyle;
	}

	function buildPrice(data, onSale, priceVaries) {
		var priceHtml = '',
			onSaleClass = onSale ? ' price--on-sale' : '';
		var soldOutClass = data.available ? '' : ' price--sold-out';
		var comparePriceVaries = data.compare_at_price_min != data.compare_at_price_max;
		var priceVariesClass = !priceVaries && comparePriceVaries ? ' price--compare-price-hidden' : '',
			variant = data.variants[0],
			unitPriceMeasurementClass = '',
			unitPriceSeparatorHtml = '',
			unitPirceBaseUnitHtml = '';

		if (variant.hasOwnProperty('unit_price_measurement')) {
			unitPriceMeasurementClass = ' price--unit-available';
		}

		priceHtml += '<dl class="price price--listing' + onSaleClass + soldOutClass + priceVariesClass + unitPriceMeasurementClass + '" data-price>';
		if (boostPFSConfig.custom.hasOwnProperty('vendor_enable') && boostPFSConfig.custom.vendor_enable == true) {
			priceHtml += '<div class="price__vendor price__vendor--listing"><dt>';
			priceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.vendor + '</span>';
			priceHtml += '</dt><dd>';
			priceHtml += data.vendor;
			priceHtml += '</dd></div>';
		}

		priceHtml += '<div class="price__regular">';
		priceHtml += '<dt><span class="visually-hidden visually-hidden--inline">' + boostPFSConfig.label.regular_price + '</span>';
		priceHtml += '</dt><dd>';
		priceHtml += '<span class="price-item price-item--regular" data-regular-price>';
		if (priceVaries) {
			priceHtml += boostPFSConfig.label.from_lowest_price_html.replace(/{{ lowest_price }}/, Utils.formatMoney(data.price_min));
		} else {
			priceHtml += Utils.formatMoney(data.price_min);
		}
		priceHtml += '</span></dd></div>';

		priceHtml += '<div class="price__sale"> <dt> <span class="visually-hidden visually-hidden--inline">';
		priceHtml += boostPFSConfig.label.sale_price +
			'</span></dt>';
		priceHtml += '<dd> <span class="price-item price-item--sale">';
		if (priceVaries) {
			priceHtml += boostPFSConfig.label.from_lowest_price_html.replace(/{{ lowest_price }}/, Utils.formatMoney(data.price_min));
		} else {
			priceHtml += Utils.formatMoney(data.price_min);
		}
		priceHtml += '</span></dd>';
		priceHtml += '<div class="price__compare"> <dt> <span class="visually-hidden visually-hidden--inline">';
		priceHtml += boostPFSConfig.label.regular_price;
		priceHtml += '</span></dt>';
		priceHtml += '<dd> <s class="price-item price-item--regular">';
		priceHtml += Utils.formatMoney(data.compare_at_price_min);
		priceHtml += '</s></dd></div>';
		priceHtml += '</div>';

		priceHtml += '<div class="price__unit"> <dt> <span class="visually-hidden visually-hidden--inline">';
		priceHtml += boostPFSConfig.label.unit_price_label;
		priceHtml += '</span></dt>';
		priceHtml += '<dd class="price-unit-price">';

		unitPriceSeparatorHtml += '<span aria-hidden="true">/</span><span class="visually-hidden">';
		unitPriceSeparatorHtml += boostPFSConfig.label.unit_price_separator + '&nbsp;</span>';

		if (variant.hasOwnProperty('unit_price_measurement') && variant.unit_price_measurement) {
			unitPirceBaseUnitHtml += '<span>';
			if (variant.hasOwnProperty('reference_value') && variant.unit_price_measurement.reference_value != 1) {
				unitPirceBaseUnitHtml += variant.unit_price_measurement.reference_value;
			}
			if (variant.hasOwnProperty('reference_unit')) {
				unitPirceBaseUnitHtml += variant.unit_price_measurement.reference_unit;
			}
			unitPirceBaseUnitHtml += '</span>';
		}

		if (variant.hasOwnProperty('unit_price')) {
			priceHtml += '<span>' + Utils.formatMoney(variant.unit_price) + '</span>';
		}

		priceHtml += unitPriceSeparatorHtml + unitPirceBaseUnitHtml;
		priceHtml += '</dd></div>';

		priceHtml += '<div class="price__badges price__badges--listing">' +
			'<span class="price__badge price__badge--sale" aria-hidden="true"> <span>';
		priceHtml += boostPFSConfig.label.sale + '</span></span>';
		priceHtml += '<span class="price__badge price__badge--sold-out">' +
			boostPFSConfig.label.sold_out +
			'</span></span></div>';

		priceHtml += '</dl>';

		return priceHtml;
	}
  
    function numberWithCurrency(x) {
      var formatted_number = x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      
      return `₱${formatted_number}`;
    }
    
  
    function getFilterData() {
      var params = {
        type: 'GET',
        url: boostPFSAppConfig.api.filterUrl,
        data: {
          shop: boostPFSAppConfig.shop.domain,
          build_filter_tree: true
        },
        dataType: 'json',
        success: function(data) {
          window.FilterData = data.filter.options;
        },
        error: function(XMLHttpRequest, textStatus) {
          console.log(XMLHttpRequest, textStatus);
        }
      };
      return params;
    }
  
    jQuery.ajax(getFilterData());
  

	/// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}

		var paginationHtml = boostPFSTemplate.paginateHtml;

		// Build Previous
		var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

		// Build Next
		var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

		// Build page items
		var currentPage = boostPFSConfig.label.current_page.replace(/{{ current }}/g, currentPage).replace(/{{ total }}/g, totalPage);
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, currentPage);

		return paginationHtml;
	};
  
  	
//     FilterMobileButton.prototype.compileTemplate = function() {
//       var filterApplyAllBtnHtml = boostPFSTemplate.applyAllButton;
      
//       return filterApplyAllBtnHtml;
//     }

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
      		var sortingItemsHtml = '';
			if (sortingArr) {
				// Build content
				for (var k in sortingArr) {
					sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	// Build Display type
	ProductDisplayType.prototype.compileTemplate = function() {
		var itemHtml = '<span>View As </span>';
		itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"><span class="fallback-text">Grid view</span></span></a>';
		itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"><span class="fallback-text">List view</span></span></a>';
		itemHtml = itemHtml.replace(/{{class.productDisplayType}}/g, Class.productDisplayType);

		return itemHtml;
	};

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data) {
		if (!data) data = this.data;
		var productSelector = jQ(Selector.products);
		if (Globals.queryParams.display == 'list') {
			if (productSelector.children('.list-view-items').length == 0) {
				productSelector.children().wrapAll('<ul class="list-view-items"></ul>');
			}
			productSelector.removeClass('grid grid--uniform grid--view-items');
		} else {
			if (productSelector.children('.list-view-items').length > 0) {
				productSelector.children('.list-view-items').children().unwrap();
			}
			productSelector.addClass('grid grid--uniform grid--view-items');
		}
      
      	var totalProduct = '';
		if (data.total_product == 1) {
			totalProduct = boostPFSConfig.label.items_with_count_one.replace(/{{ count }}/g, data.length);
		} else {
			totalProduct = boostPFSConfig.label.items_with_count_other.replace(/{{ count }}/g, data.length);
		}
      
      
		jQ('.boost-pfs-filter-total-product').html(totalProduct);
	}
    
	
     
	// Build Additional Elements
	FilterResult.prototype.afterRender = function(data, eventType) {
		if (!data) data = this.data;
		var totalProduct = '';
		if (data.total_product == 1) {
			totalProduct = boostPFSConfig.label.items_with_count_one.replace(/{{ count }}/g, data.total_product);
		} else {
			totalProduct = boostPFSConfig.label.items_with_count_other.replace(/{{ count }}/g, data.total_product);
		}
      
      	var locationPath = location.pathname,
            sortVal = null;
        
        
      
      	
		// console.log("wishing",window._swat)
        if(window._swat != undefined) {
			window._swat.fetch(function(r) {
			//Update heart icon item count
			$('.c-favourites-counter__label').html(`${r.length}`);
	
			r.map(item => {
				window.updateIcons('add', item)
			})
			});
		}

      
      	if($('.c-product-landing-header').length <= 0) {
          jQ('.boost-pfs-filter-products').prepend(boostPFSTemplate.productLandingHeader);
        }
      
		jQ('.boost-pfs-filter-total-product').html(totalProduct);
      	
        if($('.c-grid-promo').eq(0).length <= 0) {
          $(boostPFSTemplate.gridCategoryOption).insertAfter(jQ('.boost-pfs-filter-products .c-product-tile').eq(2));
        }
      	
        if(locationPath != '/search') {
          //For large cards
          var product_card = jQ('.boost-pfs-filter-products .c-product-tile'),
              number_of_large_card = Math.ceil(product_card.length / 8),
              starter_index = 0;

          for(var a =0; a < number_of_large_card; a++){
            if(starter_index!=0) product_card.eq(starter_index).addClass('c-product-tile--is-large o-box-6@lg o-box-8@md o-tile--is-large o-box-12').removeClass('o-box-3@lg o-box-4@md o-box-6');
            starter_index += 8;
          }
        }
      	//Show desktop filter
      	var filterBtn = $('.c-grid-controls-filters__filter-trigger'),
            closeFilterBtn = $('.c-filters-overlay__close');
        
        filterBtn.click(showFilter)
        closeFilterBtn.click(hideFilter)
        
      
         
        function showFilter() {
          if(Utils.isMobile()) {
            $('.boost-pfs-filter-tree-mobile-button button').trigger('click')
          }else {
            var overlayContainer = $('.c-overlay'),
                overlayBg = overlayContainer.find('.c-dimmer'),
                overlayFilter = overlayContainer.find('.c-filters-overlay');
            overlayContainer.toggleClass('c-overlay--is-visible');
            overlayBg.toggleClass('c-dimmer--is-white');
            overlayFilter.toggleClass('js-hidden');
          }
        }
      
        function hideFilter() {
          var overlayContainer = $('.c-overlay'),
              overlayBg = overlayContainer.find('.c-dimmer'),
              overlayFilter = overlayContainer.find('.c-filters-overlay');
          overlayContainer.removeClass('c-overlay--is-visible');
          overlayBg.removeClass('c-dimmer--is-white');
          overlayFilter.addClass('js-hidden');
        }
      
        
        //Clear filter
        var clrBtn = $('.c-filters-overlay-controls__clear-btn');
      
        clrBtn.click(function() {
          $('button.boost-pfs-filter-button.boost-pfs-filter-clear-all').trigger('click')
          $('.c-filters-overlay-controls__apply-btn .u-btn__content').html('Apply')
        })
        
        var filterAppluBtns = $('button.boost-pfs-filter-button.boost-pfs-filter-apply-button'),
            filterBtns = $('button.boost-pfs-filter-button'),
            filterApplyAllBtn = $(`.${window.Class.applyAllButton}`),
            customFilterApplyAllBtn = $('.c-filters-overlay-controls__apply-btn');
      
        var filterOpt = $('.boost-pfs-filter-option'),
            filterOptCount = filterOpt.length,
            percentWidth = `${filterOptCount * 20}%`,
            items = filterOpt.find('li.boost-pfs-filter-option-item.boost-pfs-filter-option-label');

        $('.boost-pfs-filter-tree-h').css('width', percentWidth);
      
      
      
      	
      
      	//Sort
      	var sortingArr = Utils.getSortingList(),
      		sortingItemsHtml = '',
			sortingItemsHtml2 = '';
		var current_sort = getCurrentUrlParam(window.location.href, "sort")
        if (sortingArr) {
          // Build content
          for (var k in sortingArr) {
            sortingItemsHtml += `<li class="c-filter-option" data-qa-id="filter-group-sort-option-0" data-qa-filter="true" data-qa-filter-${k}="true" data-qa-filter-sort="true">
                                <div class="c-form-field-wrapper" id="sort-${k}-validation">
                                <input class="c-form-field-radio boost-pfs-filter-top-sorting-select filters-toolbar__input js-sort-filter" data-qa-radio="true" id="sort-${k}" name="sort" title="${sortingArr[k]}" type="radio" value="${k}">
                                <label aria-describedby="sort-${k}-validation" class="u-text-thin c-form-field-wrapper__label" data-qa-label="true" for="sort-${k}">
                                <span class="u-visually-hidden"></span>
                                ${sortingArr[k]}
                                </label>
                                </div>
                                </li>`
			sortingItemsHtml2 += `
			                        <div class="c-form-field-wrapper" data-qa-id="${k}-radio" id="${k}-radio-validation">
									<input ${(current_sort == k || (!current_sort && k == 'manual')) ? 'checked' : ''} class="c-form-field-radio" data-qa-id="" data-qa-radio="true" id="${k}-radio" name="sort-radio" title="${k}" type="radio" value="${k}">
									<label class="u-text-thin c-form-field-wrapper__label" data-qa-label="true" for="${k}-radio" id="${k}-radio-label">${sortingArr[k]}
									</label>
									</div>
			`
          }
        }

		$('.c-sort-menu__options-content').html(sortingItemsHtml2);


      	$('.filter-group-sort ul.c-filter-group__list').html(sortingItemsHtml);

        //Custom sort
        $('.js-sort-filter').change(function(e) {
          var $this = $(this),
              val = $this.val();

          sortVal = val;
        })

		$('input[name="sort-radio"]').change(function(e) {
			var $this = $(this);
			applySort($this.val());
		});
        //Get sort value thru URL parameter
        

        //Check the sort radio input associated to the current sort value
        if(current_sort) {
          $(`.js-sort-filter[value="${current_sort}"]`).prop("checked", true)
        }


        //Apply sort function
        function applySort(value) {
          window.FilterApi.setParam("sort", value);
          window.FilterApi.setParam("page", 1);
          window.FilterApi.applyFilter("sort")
        }

        //Trigger apply all button
        setTimeout(function() {

          var filterApplyAllBtn = $(`.${window.Class.applyAllButton}`)

          customFilterApplyAllBtn.click(function(e) {
            
            //Trigger applyAllButton 
            filterApplyAllBtn.trigger('click')
            
            //Hide filter panel
            hideFilter();
            
            //Apply sort
            if(sortVal) {
              applySort(sortVal);
            }
          })


        }, 1000)

        //Count selected Filter onClick event
        $(document).on('click','li.boost-pfs-filter-option-item',function(){
          var $this = $(this),
              selectedFilterCount = $('li.boost-pfs-filter-option-item.selected').length

          var filter_button_apply_label = $('.c-filters-overlay-controls__apply-btn .u-btn__content'),
              filter_label = ''


          if(selectedFilterCount > 0) {
            if(selectedFilterCount == 1) {
              filter_label = `Apply ${selectedFilterCount} filter`;
            }else {
              filter_label = `Apply ${selectedFilterCount} filters`;
            }
          }else {
            filter_label = `Apply`;
          }

          filter_button_apply_label.html(filter_label);

        })
        
        
		//Filter panel loading animation
        function animateLoadingFilter() {
          var loader = $('.c-filters-overlay__inner .c-dimmer'),
              oLoader = $('.c-filters-overlay__inner .o-loader')

          loader.addClass('c-dimmer--is-visible')
          loader.addClass('c-dimmer--is-white')
          oLoader.toggle()
          setTimeout(function() {
            hideFilterLoader()
            oLoader.toggle();
          }, 1000)

        }

        function hideFilterLoader() {
          var loader = $('.c-filters-overlay__inner .c-dimmer')
          loader.removeClass('c-dimmer--is-visible')
        }

        //Get url parameter function
        function getCurrentUrlParam(url, paramKey) {
          var url_location = new URL(url);
          var value = url_location.searchParams.get(paramKey);

          return value;
        }
      
        $('.c-accordion-item-header').click(function() {
          var $this = $(this),
              filterOptionsParent = $this.parent().find('.c-accordion-item'),
              Ahidden = filterOptionsParent.attr("aria-hidden") == "true" ? true : false,
              Aexpanded = $this.attr("aria-expanded") == "true" ? true : false,
              Aselected = $this.attr("aria-selected") == "true" ? true : false;
          $this.attr('aria-expanded', !Aexpanded);
          $this.attr('aria-selected', !Aselected);
          filterOptionsParent.attr('aria-hidden', !Ahidden);
          filterOptionsParent.find('.c-accordion-item__content').slideToggle();
          $this.parent().siblings().find('.c-accordion-item__content').slideUp()
        })
        
        $('.c-filter-group__list .c-filter-option').click(function(e) {
          var $this = $(this),
              $input = $this.find('input');
          
          $this.toggleClass('o-option-rectangle--is-checked');
          if($input.length > 0) {
            $input.prop("checked", !$input.prop("checked"));
          }
          console.log(e.target);
        })
        
        function mobileFilterAccordion() {
          var items = $('.c-accordion-item')
          items.each((i, item) => {
            var parent = $(item).parent(),
                isHidden = parent.attr("aria-hidden") == "true" ? true : false;
            
            if(!isHidden) {
              $(item).find('.c-accordion-item__content').slideDown();
            }else {
              $(item).find('.c-accordion-item__content').slideUp();
            }
          })
        }
      
      
      	//Apply all example
//         var v = [6.5, 6]
//         window.FilterApi.setParam("pf_opt_size", v);
//         window.FilterApi.setParam("page", 1);
//         window.FilterApi.applyFilter("filter")
	};
})();